import fetch from '../utils/fetch';

// 获取首屏数据
export function getFirstScreen() {
  return fetch.get(`/marketing/api/feature/getFirstScreen`);
}

export function getShopBasicInfo(id) {
  return fetch.get(`/newretail/api/shop/getBasicInfo?id=${id}`);
}
